import { categories } from "@/mocks/varietyShows";

interface StructuredDataProps {
  type: "Organization" | "WebSite" | "WebPage" | "BreadcrumbList" | "FAQPage";
  data?: Record<string, unknown>;
  breadcrumbItems?: Array<{ name: string; url: string }>;
  faqItems?: Array<{ question: string; answer: string }>;
}

function StructuredData({ type, data, breadcrumbItems, faqItems }: StructuredDataProps) {
  let jsonLd: Record<string, unknown>;

  switch (type) {
    case "Organization":
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "红桃影院",
        url: "https://hongtao-movie.com",
        logo: "https://hongtao-movie.com/logo.png",
        description: "红桃影院 - 综艺在线观看平台，提供热门综艺、真人秀、搞笑综艺等高清在线观看服务",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "400-888-6666",
          contactType: "customer service",
          email: "contact@hongtao-movie.com",
        },
        sameAs: ["https://weibo.com/hongtao", "https://weixin.qq.com/hongtao"],
        ...data,
      };
      break;

    case "WebSite":
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "红桃影院",
        url: "https://hongtao-movie.com",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://hongtao-movie.com/search?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
        ...data,
      };
      break;

    case "WebPage":
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: data?.name || "红桃影院",
        url: data?.url || "https://hongtao-movie.com",
        description: data?.description || "红桃影院综艺在线观看专区，热门综艺、真人秀免费看",
        ...data,
      };
      break;

    case "BreadcrumbList":
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: (breadcrumbItems || []).map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: item.name,
          item: item.url,
        })),
      };
      break;

    case "FAQPage":
      jsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: (faqItems || []).map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      };
      break;

    default:
      jsonLd = {};
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}

export function OrganizationSchema() {
  return <StructuredData type="Organization" />;
}

export function WebSiteSchema() {
  return <StructuredData type="WebSite" />;
}

export function WebPageSchema({ name, url, description }: { name: string; url: string; description: string }) {
  return <StructuredData type="WebPage" data={{ name, url, description }} />;
}

export function BreadcrumbListSchema({ items }: { items: Array<{ name: string; url: string }> }) {
  return <StructuredData type="BreadcrumbList" breadcrumbItems={items} />;
}

export function FAQPageSchema({ items }: { items: Array<{ question: string; answer: string }> }) {
  return <StructuredData type="FAQPage" faqItems={items} />;
}

export const categoryNames: Record<string, string> = {};
categories.forEach((c) => {
  categoryNames[c.slug] = c.name;
});